
import axios from '../../api'
const state = {
    OrgUnitTaskReportList: [],
    LoadedChart: false,
    OrgUnitTaskReportDetailsList: [],
    OrgUnitReportListNoMoreData: false,
};


const getters = {
    GetOrgUnitTaskReportList(state:any) {
        return state.OrgUnitTaskReportList;
    },
    GetOrgUnitTaskReportDetailsList(state:any) {
        return state.OrgUnitTaskReportDetailsList;
    },
    GetLoadedChart(state:any) {
        return state.LoadedChart;
    },
    GetOrgUnitReportListNoMoreData(state:any) {
        return state.OrgUnitReportListNoMoreData;
    }
};

const mutations = {
    SetOrgUnitTaskReportList(state:any, list:any) {
        state.OrgUnitTaskReportList = list;
    },
    SetOrgUnitTaskReportDetailsList(state:any, list:any) {
        state.OrgUnitTaskReportDetailsList = list;
    },
    AddOrgUnitTaskReportDetailsList(state:any, list:any) {

        state.OrgUnitTaskReportDetailsList= state.OrgUnitTaskReportDetailsList.concat(list);
    },
    SetLoadedChart(state:any,val:any) {
        state.LoadedChart = val;
    },
    SetOrgUnitReportListNoMoreData(state:any, val:any) {
        state.OrgUnitReportListNoMoreData = val;
    }
};

const actions = {
    GetOrgUnitTaskReportListFromServer(context:any) {
        axios.get("Report/OrgUnitTaskReport", {
            params: {
                fromDate: null,
                tillDate:null,
                
            }
        }).then(data => {
                context.commit("SetOrgUnitTaskReportList", data.data.condition.taskStatusReport);
                context.commit("SetLoadedChart", true);
            }, data => { console.log(data) });
    },
    GetOrgUnitTaskReportDetailsListFromServer(context:any, Filter:any) {
        context.commit("SetLoading", true);
         axios.get("Report/GetTaskStatusReportDetails", {
            params: {
                orgCode: Filter.orgCode,
                 status: Filter.status,
                 page: Filter.pageId
            }
        }).then((response:any) => {
            return response.json();
        }).then(data => {
            context.commit("SetLoading", false);
            if (data.data.length == 0) {
                context.commit("SetOrgUnitReportListNoMoreData", true);
            }
            else {
                context.commit("SetOrgUnitReportListNoMoreData", false);
            }

            if (Filter.pageId === 1) {
                context.commit("SetOrgUnitTaskReportDetailsList", data.data);
            }
            else {
                context.commit("AddOrgUnitTaskReportDetailsList", data.data);
            }
            context.commit("SetLoadedChart", true);
            context.commit("SetLoading", false);
        }, data => { console.log(data) });
    },
    ClearOrgUnitTaskReportDetailsList(context:any) {
        context.commit("SetOrgUnitTaskReportDetailsList", []);
    }

};

export default {
    state,
    getters,
    mutations,
    actions
};
